import React from 'react';
import Button from '@tt2/components/build/Atoms/Button';
import Dialog from '@tt2/components/build/Atoms/Dialog';
import DialogContent from '@tt2/components/build/Atoms/DialogContent';
import Alert from 'components/Alert';
import NewsletterConsentText from 'components/NewsletterConsentText';
import constants from 'src/constants';
import transl from 'src/utils/translate';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { User } from 'store/User/User.types';
import { updateNewsletterConsentAsync } from 'store/User/User.actions';
import { isNewsletterConsentRequiredSelector } from 'store/User/User.selectors';
import styles from './NewsletterConsentDialog.css';

type OwnProps = unknown;
type StateProps = {
  isOpen: boolean;
  loading: boolean;
  error: string;
};
type ActionProps = {
  saveConsent: (params: User.UpdateNewsletterConsentReq) => void;
};

export type NewsletterConsentDialogProps = OwnProps & StateProps & ActionProps;

const preventClose = (): void => undefined;

export const NewsletterConsentDialog: React.FC<NewsletterConsentDialogProps> = ({
  isOpen,
  loading,
  error,
  saveConsent,
}) => (
  <Dialog isOpen={isOpen} onClose={preventClose}>
    <DialogContent
      width={constants.DIALOG_WIDTH}
      header={transl('Newsletter.Dialog.Header')}
      footer={
        <>
          <Button
            isLoading={loading}
            classNames={{ button: styles.consentButton }}
            onClick={() => saveConsent({ accepted: true })}
            type="submit"
            data-test-id="newsletter-allow"
          >
            {transl('Newsletter.Dialog.Button.Allow')}
          </Button>
          <Button
            action="secondary"
            isLoading={loading}
            classNames={{ button: styles.consentButton }}
            onClick={() => saveConsent({ accepted: false })}
            data-test-id="newsletter-deny"
          >
            {transl('Newsletter.Dialog.Button.Deny')}
          </Button>
        </>
      }
    >
      <div className={styles.container}>
        <p className={styles.title} data-test-id="newsletter-dialog-title">
          {transl('Newsletter.Dialog.Title')}
        </p>
        <p className={styles.body}>
          <NewsletterConsentText />
        </p>
      </div>
      {error && <Alert type="error">{error}</Alert>}
    </DialogContent>
  </Dialog>
);

const mapStateToProps: MapStateToProps<StateProps, OwnProps, RootState> = (state) => ({
  isOpen: isNewsletterConsentRequiredSelector(state),
  loading: state.user.loading.updateNewsletterConsentAsync,
  error: state.user.error.updateNewsletterConsentAsync,
});

const mapDispatchToProps: MapDispatchToProps<ActionProps, OwnProps> = {
  saveConsent: updateNewsletterConsentAsync.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsletterConsentDialog);
